import { render } from "./MainScreen.vue?vue&type=template&id=83f69318"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__